import gaugeKnobIcon from '../../assets/icons/point-gauge-knob.svg';
import pBoxIcon from '../../assets/icons/p_box.png';
import worldcupMoveGif from '../../assets/images/worldcup/worldcup-move.gif';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import useSWR from 'swr';
import { AuthContext } from '../../context/AuthContext';
import { getGetMainMarkItemListUrl } from '../../api/generated/time-nyang/main/main.ts';
import NPayIcon from '../../assets/icons/badge_npay.svg';

function PlaygroundPointCard({ point = 0 }) {
  const navigate = useNavigate();
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken } = useContext(AuthContext);
  const accessToken = useAccessToken();
  const { data: mainMarkInfo } = useSWR(
    accessToken && [`${API_SERVER_DOMAIN}${getGetMainMarkItemListUrl()}`, accessToken],
    fetchWithToken,
  );

  const displayPoint = Number.isFinite(point) ? point : 0;
  const mainMarkItems = Array.isArray(mainMarkInfo?.mainMarkItems)
    ? mainMarkInfo.mainMarkItems
        .filter((item) => Number.isFinite(item?.goodsPrice))
        .sort((a, b) => (a?.goodsPrice ?? 0) - (b?.goodsPrice ?? 0))
    : [];
  const selectedMarkTarget =
    mainMarkItems.find((item) => displayPoint <= (item?.goodsPrice ?? Number.MAX_SAFE_INTEGER)) ??
    mainMarkItems[mainMarkItems.length - 1];
  const targetPoint = Math.max(1, Number(selectedMarkTarget?.goodsPrice ?? 1));
  const progressRatio = Math.max(0, Math.min(displayPoint / targetPoint, 1));
  const progressPercent = progressRatio * 100;
  const knobPercent = Math.max(1.5, Math.min(progressPercent, 98.5));

  return (
    <div className="flex w-full items-center justify-between px-2">
      <div className="relative flex h-[254px] w-full items-center justify-center rounded-[10px] bg-gradient-to-b from-purple-300/20 to-violet-100/20 shadow-[0px_4px_16px_0px_rgba(0,0,0,0.15),inset_0px_-10px_10px_0px_rgba(255,255,255,0.25)]">
        <div
          className="pointer-events-none absolute inset-0 rounded-[10px]"
          style={{ border: '0.5px solid white' }}
          aria-hidden="true"
        />
        {/* <button
          type="button"
          className="absolute left-[8px] top-[0px] z-10 border-0 bg-transparent p-0"
          onClick={() => navigate('/worldcup-event')}
          aria-label="월드컵 이벤트 페이지로 이동"
        >
          <img src={worldcupMoveGif} alt="지금참여 월드컵 이벤트" className="h-[126px] w-auto object-contain" />
        </button> */}
        <div className="inline-flex w-full flex-col items-center justify-start gap-6">
          <div className="relative flex flex-col items-center">
            <img src={pBoxIcon} alt="포인트 박스" className="h-[152px] w-[152px] object-contain" />
            <button
              type="button"
              className="relative -mt-6 inline-flex cursor-pointer items-center justify-center gap-1 overflow-hidden rounded-xl border-0 bg-gradient-to-b from-[#4066D9] to-[#9259D8] px-8 py-3 shadow-[0px_8px_20px_0px_rgba(75,91,193,1)] outline-none"
              onClick={() => navigate('/user/points')}
              aria-label="내 포인트 보기"
            >
              <div className="z-10 text-center text-xl font-extrabold text-white font-['Inter'] leading-none">
                {displayPoint.toLocaleString()}
              </div>
              <div className="z-10 text-center text-base font-bold text-white font-['Pretendard'] leading-none">P</div>
              <div className="absolute left-0 top-[-0.67px] h-[2.8125rem] w-[8.125rem] rounded-[30px] bg-gradient-to-l from-white/0 via-white/50 to-white/0" />
            </button>
          </div>

          <div className="flex w-full flex-col items-center justify-start gap-3 px-[1.875rem]">
            <div className="flex w-full flex-col items-end justify-start gap-2.5">
              <div className="flex w-full flex-col items-start justify-center rounded bg-black/10">
                <div className="relative h-2 w-full rounded-full bg-[#98A2D9]/45">
                  <div
                    className="absolute left-0 top-0 h-2 rounded-full bg-[#3B5CD2]"
                    style={{ width: `${progressPercent}%` }}
                  />
                  <img
                    src={gaugeKnobIcon}
                    alt="게이지 포인터"
                    className="absolute top-[70%] h-[30px] w-[30px] -translate-x-1/2 -translate-y-1/2"
                    style={{ left: `${knobPercent}%` }}
                  />
                </div>
              </div>
            </div>

            <div className="inline-flex items-center justify-start gap-3.5 mb-3">
              <div className="flex items-center justify-center text-sm font-extrabold text-white font-['Pretendard']">
                <button
                  type="button"
                  className="mr-1 cursor-pointer border-0 bg-transparent p-0 outline-none"
                  onClick={() => navigate('/coupons', { state: { selectedBrand: '네이버페이' } })}
                  aria-label="네이버페이 상품 보기"
                >
                  <img
                    src={NPayIcon}
                    alt="n_pay"
                    className="h-[18px] w-[44px] object-contain"
                    style={{ display: 'inline-block', verticalAlign: 'middle' }}
                  />
                </button>
                <span className="align-middle">
                  {selectedMarkTarget?.goodsName || selectedMarkTarget?.goodsGoodsName || '상품권'}까지
                </span>
              </div>

              <div className="h-4 w-px bg-white/50" />
              <div className="inline-flex items-center justify-center text-right">
                <span className="text-sm font-extrabold leading-none tracking-tight text-white font-['Pretendard']">
                  {displayPoint.toLocaleString()}
                </span>
                <span className="text-xs font-extrabold leading-none tracking-tight text-[#3B5CD2] font-['Pretendard'] mx-1">
                  /
                </span>
                <span className="text-sm font-extrabold leading-none tracking-tight text-[#3B5CD2] font-['Pretendard']">
                  {targetPoint.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlaygroundPointCard;
